import scrollState from "../../../core/scrollState";
import $ from "jquery";

const ZONE_HEIGHT_WITH_FIXED_HEADER = 70;
let wrapperHeader;
let topHeaderHeight;
let oldScrollY = 0;

export const eventMobileHeader = () => {
    wrapperHeader = $("#wrapper__header");

    setTimeout(() => {
        topHeaderHeight = wrapperHeader.height();
    }, 500);
};

export const eventScrollTracker = () => {
    const scrolled = window.pageYOffset || document.documentElement.scrollTop;
    const scrollY = scrolled - oldScrollY;

    scrollState.changeScrollTracker(scrollState.getScrollTrackerState().scrollTracker + scrollY);

    if (scrolled < ZONE_HEIGHT_WITH_FIXED_HEADER) {
        scrollState.changeScrollTracker(0);
    } else if (scrollState.getScrollTrackerState().scrollTracker > topHeaderHeight) {
        scrollState.changeScrollTracker(topHeaderHeight);
    } else if (scrollState.getScrollTrackerState().scrollTracker < 0) {
        scrollState.changeScrollTracker(0);
    }

    oldScrollY = scrolled;
    $('.branding #adv-link').css(
        'top',
        `${parseInt($('.branding #adv-link').data('startTop') - scrollState.getScrollTrackerState().scrollTracker)}px`
    );

    wrapperHeader.css({marginTop: -scrollState.getScrollTrackerState().scrollTracker});
};
